module.exports = __webpack_public_path__ + "static/garda_main_4-14cb672e9524d94213c8e43fe45bf024.png";